import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Lot 603 — nouvelle page (lien, onglet : PUSH/REPLACE) → la fenêtre repart EN HAUT (en-tête du profil, barre de recherche
// des églises…). Retour arrière (POP) → position laissée aux pages qui se ré-ancrent elles-mêmes (fil, profils déjà vus).
// useLayoutEffect : avant la peinture et avant les effets de ré-ancrage des pages, qui gardent donc le dernier mot.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const prev = useRef(pathname);
  useLayoutEffect(() => {
    if (prev.current === pathname) return;
    prev.current = pathname;
    if (navType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
};

export default ScrollToTop;
